export enum REVIEW_STATUS{
  SEP_NOT_STARTED = "Received",
  SEP_PENDING = "Under Review",
  SEP_APPROVED = "Approved",
  SEP_SUBMITTED = "Approved & Submitted",
  SEP_DENIED = "Not Approved",
  NON_SEP = "Submitted"
}